import { isBefore } from 'date-fns';
import { GiBrazil } from 'react-icons/gi';
import { useLocation } from 'react-router-dom';
import searchIcon from '../../assets/assets/search.svg';
import closeIcon from '../../assets/assets/close.svg';
import { FiltrosDiv, Selects } from '../../components/components/Header/styles';
import Footer from '../../components/Footer/Footer';
import { Header } from '../../components/Header/Header';
import { MonitoramentoOnline } from '../../components/MonitoramentoOnline';
import Sidebar from '../../components/Sidebar/Sidebar';
import { useDashboard } from '../../context/context/DashboardContext';
import { useHeaderFilter } from '../../hooks/hooks/useHeaderFilter';
import { useLoading } from '../../hooks/hooks/useLoading';
import { useSelectComponent } from '../../hooks/hooks/useSelectComponent';
import { Container, Content } from './styles';
import { useState } from 'react';
import arrowGray from '../../assets/assets/arrow_gray.svg';
import { SelectAccount } from '../../components/Select/SelectAccount';

function Dashboard() {
  const { showLoader } = useLoading();
  const [account, setAccount] = useState('Principal');
  const [portal, setPortal] = useState('Todos');
  const {
    setDataFimHeader,
    setDataInicioHeader,
    dataFim,
    dataInicio,
    filtroDataCredorDashboard,
    setFiltro,
    filtrado,
  } = useHeaderFilter();
  const { setHistorico } = useDashboard();
  const { onOptionSelected } = useSelectComponent();
  const location = useLocation();

  async function handleSubmit() {
    setFiltro(true);
    showLoader();
    const isBeforeDate = isBefore(new Date(dataInicio), new Date(dataFim));
    if (isBeforeDate || dataInicio === dataFim) {
      let isCancelar = false;
      setHistorico('Histórico', 'brown');

      await filtroDataCredorDashboard(isCancelar, location.pathname);
    }
  }

  async function cancelaFiltro() {
    setFiltro(false);
    let isCancelar = true;
    setHistorico('Real Time', 'green');
    onOptionSelected('Todos', true);
    await filtroDataCredorDashboard(isCancelar, location.pathname);
  }
  return (
    <>
      <Sidebar />
      <Container>
        <Content>
          <Header
            icon={<GiBrazil color="#A6A6A6" size="32px" />}
            title="Dashboard"
          >
            <div
              style={{
                height: '70px',
                borderBottom: '1px solid var(--color-primary)',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '2rem',
                fontSize: '8px',
                fontWeight: 300,
              }}
            >
              <Selects>
                <FiltrosDiv>
                  <p>Inicio: </p>
                  <input
                    type="date"
                    value={dataInicio}
                    onChange={(e) => setDataInicioHeader(e.target.value)}
                    max={dataFim}
                  />
                  <p>Final: </p>
                  <input
                    type="date"
                    value={dataFim}
                    onChange={(e) => setDataFimHeader(e.target.value)}
                    min={dataInicio}
                  />
                  <p style={{ marginRight: '1rem' }}>Conta: </p>
                  <SelectAccount
                    setAccount={setAccount}
                    account={account}
                    options={['Principal', 'Parcelamento']}
                    nameSelect="Selecione"
                    icon={arrowGray}
                  />
                  <p style={{ marginRight: '1rem', marginLeft: '1rem' }}>
                    Canal:{' '}
                  </p>
                  <SelectAccount
                    setAccount={setPortal}
                    account={portal}
                    options={['Portal', 'Whatsapp', 'Todos']}
                    nameSelect="Selecione"
                    icon={arrowGray}
                  />

                  <button onClick={handleSubmit}>
                    <img src={searchIcon} alt="Filtrar" />
                  </button>

                  {filtrado && (
                    <button onClick={cancelaFiltro}>
                      <img src={closeIcon} alt="Cancelar filtro" />
                    </button>
                  )}
                </FiltrosDiv>
              </Selects>
            </div>
          </Header>
          <MonitoramentoOnline account={account} appAcesso={portal} />
        </Content>
        <Footer />
      </Container>
    </>
  );
}

export default Dashboard;
